import { useCallback } from "react"
import { intlFormat } from "date-fns"
import { DateUtils } from "@indeed/frontend-i18n-utils"
import { useLocale } from "./useLocale"

export type DateStyle = "short" | "long" | "preferred"

type DateFormatter = (date: Date, formatArguments: { dateStyle: DateStyle }) => string

export function useDateFormatter(): DateFormatter {
    let locale = useLocale()
    return useCallback((date: Date, { dateStyle }) => {
        locale = locale.replace("_", "-").toLocaleLowerCase()
        const dateTimeFormat = { ...fallbackDateFormat[dateStyle] }

        return DateUtils.formatDate(date, locale, dateTimeFormat)
    }, [])
}

const fallbackDateFormat: Record<DateStyle, Parameters<typeof intlFormat>[1]> = {
    short: { month: "2-digit", day: "2-digit", year: "numeric" },
    long: { month: "long", day: "numeric", year: "numeric" },
    preferred: { month: "2-digit", day: "2-digit", year: "numeric" },
}
